// extracted by mini-css-extract-plugin
export default {"profile":"ProfilePage_profile__LMYrN"};